import React, { Component } from 'react';
import Modal from 'react-modal';
import Recaptcha from 'react-recaptcha';

Modal.setAppElement('#root');

class CaptchaModal extends Component {
  state = {
    captcha: false,
  }

  recaptchaLoaded = () => {
    console.log('Capcha successfully loaded!');
  }

  verifyCallback = (response) => {
    const { sendEmail } = this.props;
    this.setState(() => ({ captcha: true }));
    sendEmail(response);
  };

  render() {
    const { isOpen, closeModalAndReset, closeModal } = this.props;
    const { captcha } = this.state;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Captcha Modal"
        closeTimeoutMS={200}
        className="modal"
        shouldCloseOnOverlayClick={false}
      >
        <div>
          <h3 className="modal__title">Prosím potvrdťe, že nie ste robot.</h3>
          <div>
            <Recaptcha
              sitekey="6LdKJ5IUAAAAAHvSQjBhp88QYnPk4kC_8dP9jvId"
              render="explicit"
              onloadCallback={this.recaptchaLoaded}
              verifyCallback={this.verifyCallback}
              expiredCallback={closeModalAndReset}
            />
          </div>
        </div>
        {captcha
          ? (
            <div className="margin-bottom-extra">
              <p className="modal__body">Ďakujeme za váš záujem. Najneskôr nasledujúci pracovný deň vás bude kontaktovať konzultant Broker Consulting. Zadané informácie boli odoslané aj na vami uvedenú emailovú adresu.“</p>
              <button className="btn btn--captcha" type="button" onClick={closeModalAndReset}>Ok</button>
            </div>
          ) : <button className="btn btn--captcha margin-bottom-extra" type="button" onClick={closeModal}>Späť</button>}
      </Modal>
    );
  }
}

export default CaptchaModal;
